import * as React from 'react';

/**
 * Hook to detect if the device is a touchscreen device
 *
 * Uses multiple detection methods:
 * - Touch event support (ontouchstart, maxTouchPoints)
 * - Pointer media query (coarse pointer = touchscreen)
 *
 * @returns {boolean} true if the device has a touchscreen
 */
export const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = React.useState(false);

  React.useEffect(() => {
    // Check if device supports touch events
    const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Check if primary pointer is coarse (touchscreen)
    const hasCoarsePointer = window.matchMedia('(pointer: coarse)').matches;

    setIsTouchDevice(hasTouchSupport || hasCoarsePointer);
  }, []);

  return isTouchDevice;
};
